import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

export const COMING_SOON = 'Coming soon';

// TODO(UPDEV-7735): add custom features here, and custom categories with UPDEV-7859; the controls mark where.
export const MatrixAddControl = ({ label }: { label: string }) => (
  <span title={COMING_SOON}>
    <Button
      size="small"
      variant="outlined"
      startIcon={<AddIcon />}
      disabled
      sx={{ borderStyle: 'dashed' }}>
      {label}
    </Button>
  </span>
);
